<script setup lang="ts">
defineProps<{
  message: string;
}>();
</script>

<template>
  <span class="text-sm text-red-600">{{ message }}</span>
</template>
